module.exports = __webpack_public_path__ + "static/media/mapNode1.7f8e351c.png";